import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ListingViewModel } from '../models';
import { DateService } from './date.service';
import { FileDownloadService } from './file-download.service';
import { HttpHelperService } from './http-helper-service.service';
import { LogService } from './log.service';

@Injectable({
  providedIn: "root",
})
export class ListingCacheService {
  private readonly _serviceName = 'ListingCacheService';
  private _listings: ListingViewModel[] = [];
  private _enabled: boolean = true;
  /**
   * Subject of the listing id whenever a new Listing is added to the Listing cache
   */
  public added = new Subject<number>();

  constructor(
    private http: HttpClient,
    private log: LogService,
    private dateService: DateService,
    private fileDownloadService: FileDownloadService,
    private httpHelper: HttpHelperService
  ) {}

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  /**
   * Gets the UTC timestamp of the Listing currentness value.  The API web method
   * does not use caches (value comes from the database)
   */
  public getCurrentness(listingId: number) {
    return this.http.get<Date>(`listing/${listingId}/currentness`);
  }

  /**
   * Gets the listing data from the cache
   * @param listingId
   */
  public getListing(listingId: number) {
    if (!this.enabled) return null;

    return this.listings.find((x) => x.id === listingId);
  }

  /**
   * Add a listing to the cache
   */
  public addListing(listing: ListingViewModel) {
    // console.log(`${this._serviceName}.addListing listing=`, listing);

    if (listing) {
      const existing = this.listings.find((x) => x.id === listing.id);

      if (existing == null) {
        this.listings.push(listing);
        if (this.verboseLogging) {
          console.log(`${this._serviceName}.addListing listing ID=${listing.id} added to listing cache.`);
        }
      } else {
        var i = this.listings.indexOf(existing);
        this.listings[i] = listing;
        if (this.verboseLogging) {
          console.log(`${this._serviceName}.addListing listing ID=${listing.id} already exists. Updated.`);
        }
      }

      this.added.next(listing.id);
    }
  }

  private get listings(): ListingViewModel[] {
    return this._listings;
  }
  private set listings(v: ListingViewModel[]) {
    this._listings = v;
  }

  public get enabled(): boolean {
    return this._enabled;
  }
  public set enabled(v: boolean) {
    this._enabled = v;
  }
}

/*
  this.getCurrentness(listing.id).subscribe(
        latestCurrentness => {
          if (this.dateService.isDateEqual(latestCurrentness, existing.currentness)) {

          }
        },
        err => {
          console.error(err);
          
        }
      );
*/
